export default __webpack_public_path__ + "static/media/icons8-twitter.fe06d572.svg";